export default __webpack_public_path__ + "static/media/resume.084c3186.pdf";